import script from "./ParentAssignDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentAssignDialog.vue?vue&type=script&setup=true&lang=js"

import "./ParentAssignDialog.vue?vue&type=style&index=0&id=15feb028&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15feb028"]])

export default __exports__